import * as a from "react";
import m from "../lib/SSRBase.es.js";
import t from "../defs/Camera.es.js";
const e = a.forwardRef((r, o) => /* @__PURE__ */ a.createElement(m, { ref: o, ...r, weights: t }));
e.displayName = "CameraIcon";
const f = e;
export {
  f as Camera,
  e as CameraIcon
};
